<template>
  <div>
    <v-container>
      <template>
        <v-treeview
          selectable
          v-model="plan"
          selected-color="blue"
          :items="gates"
        ></v-treeview>
      </template>
      <hr />
      <v-btn color="blue darken-1" style="float: right;" text @click="save()">
        değişiklikleri kaydet
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
import { mapState } from "vuex";
export default {
  name: "CompanySubscriptionPlan",
  props: ["company", "popUpStatus"],
  data() {
    return {
      plan: null,
    };
  },
  created() {
    this.onCreate();
  },
  computed: {
    ...mapState(["gates"]),
  },
  watch: {
    popUpStatus() {
      this.onCreate();
    },
  },
  methods: {
    onCreate() {
      this.plan = JSON.parse(JSON.stringify(this.company.subscriptionPlan));
    },
    save() {
      userReq
        .updateCompanySubscriptionPlan(this.company.id, this.plan)
        .then((res) => {
          if (res.data.data.value >= 1) {
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: "Kaydedildi",
              timeout: 1500,
            };
            this.$emit("refresh");
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style></style>
